var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePaperclip2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32 20.1a4.249 4.249 0 0 1 0-6.01l2.48-2.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.48 2.47a2.758 2.758 0 0 0 0 3.89 2.758 2.758 0 0 0 3.89 0l3.89-3.89a6.21 6.21 0 0 0 1.83-4.42c0-1.67-.65-3.24-1.83-4.42a6.253 6.253 0 0 0-8.84 0l-4.24 4.24a5.22 5.22 0 0 0-1.54 3.71c0 1.4.55 2.72 1.54 3.71.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0a6.736 6.736 0 0 1-1.98-4.77c0-1.8.7-3.5 1.98-4.77l4.24-4.24c3.02-3.02 7.94-3.02 10.96 0a7.709 7.709 0 0 1 2.27 5.48c0 2.07-.81 4.02-2.27 5.48l-3.89 3.89c-.83.83-1.91 1.24-3 1.24s-2.18-.41-3.01-1.24z",
    fill: "{props.color}",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePaperclip2);
export default __webpack_public_path__ + "static/media/vuesax-outline-paperclip-2.03d0a526e7f7f15c996ebb19680c7491.svg";
export { ForwardRef as ReactComponent };